import { render, staticRenderFns } from "./score_Proportion_tea_old.vue?vue&type=template&id=c8cccb6c&scoped=true&"
import script from "./score_Proportion_tea_old.vue?vue&type=script&lang=js&"
export * from "./score_Proportion_tea_old.vue?vue&type=script&lang=js&"
import style0 from "./score_Proportion_tea_old.vue?vue&type=style&index=0&id=c8cccb6c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8cccb6c",
  null
  
)

export default component.exports